module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    class: {
      'bold': _vm.bold
    }
  }, _vm._l((_vm.lista), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e718a04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ui-numlist.vue
// module id = 1044
// module chunks = 1